module.exports = __webpack_public_path__ + "static/media/3.1.9b0ad923.zip";